import { CommonMessages } from "../messages/validationMessages"
import * as Yup from 'yup'
import { EMAIL_REGEX, PHONE_REGEX,MIN_PASSWORD_LENGTH } from "../utils/constants"
import { requiredPostalCode } from "./postalCodeSchema"

export const cwoaddCarwashSchema = Yup.object().shape({
    washname: Yup.string().required(CommonMessages.washname_required),
    address: Yup.string().required(CommonMessages.address_required),
    city: Yup.string().required(CommonMessages.city_required),
    country: Yup.string().required(CommonMessages.country_required),
    state: Yup.string().required(CommonMessages.state_required),
    zipcode: requiredPostalCode(),
    name: Yup.string().required(CommonMessages.name_required),
    emailid: Yup.string()
        .matches(EMAIL_REGEX, CommonMessages.email_invalid)
        .required(CommonMessages.email_required),
    phonenumber: Yup.string()
        .matches(PHONE_REGEX, 'Phone number is not valid')
        .required(CommonMessages.phone_required),
    password: Yup.string().trim().min(MIN_PASSWORD_LENGTH, CommonMessages.password_minimum).required(CommonMessages.password_required),
    
});

export const cwoaddACHBankAccountSchema = Yup.object().shape({
    accountholdertype: Yup.string()
        .required(CommonMessages.accountholder_required)
        .notOneOf(['0'], CommonMessages.accountholder_required),
    accountholdername: Yup.string()
        .required(CommonMessages.accountname_required),
    accountnumber: Yup.string()
    .required(CommonMessages.accountnumber_required)
    .matches(/^\d{6,17}$/, CommonMessages.accountnumber_mismatch)
    .test('no-x-characters', CommonMessages.accountnumber_fullrequired, (value) => {
        // Check if the value contains "XXXX"
        return !value || !value.includes('XXXX');
    }),
    retypeaccountnumber: Yup.string()
    .required(CommonMessages.accountnumber_required)
    .matches(/^\d{6,17}$/, CommonMessages.accountnumber_mismatch)
    .trim()
    .oneOf([Yup.ref('accountnumber')], CommonMessages.accountnumber_match)
    .test('no-x-characters', CommonMessages.accountnumber_fullrequired, (value) => {
        // Check if the value contains "XXXX"
        return !value || !value.includes('XXXX');
    }),
    routingnumber: Yup.string()
        .required(CommonMessages.routingnumber_required)
        .matches(/^\d{9}$/, CommonMessages.routingnumber_mismatch),
    
    
});